import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "src/app/shared/services/common-service";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { catchError } from "rxjs/operators";
import { ReturnStruct } from "src/app/shared/structs/return.struct";
import { PrescriptionNonDispensationRequest } from "../../requests/medical-record/prescription-non-dispensation.request";
import { LiberateSolutionPrescriptionRequest } from "../../requests/orchestrator-patient/liberate-solution-prescription.request";
import { SolutionNonDispesationRequest } from "../../requests/pharmacy/solution-non-dispesation.request";

@Injectable({
  providedIn: 'root'
})
export class PrescriptionNonDispensationService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }  
  
  public nonDispensation(body: PrescriptionNonDispensationRequest): Observable<ReturnStruct> {
    let uri = `PrescriptionNonDispensation/`

    return this.httpClient.put<ReturnStruct>(environment.urlApiPharmacy + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
  
  public nonDispensationSolution(body: SolutionNonDispesationRequest): Observable<ReturnStruct> {
    let uri = `PrescriptionNonDispensation/prescriptionSolution`

    return this.httpClient.put<ReturnStruct>(environment.urlApiPharmacy + uri, body, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

}